import { inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { DataserviceHttpHeaders, RolRestriction, RRol } from '@cumlaude/service-contract';
import { RestLoggingService } from './rest.logging.service';

/**
 * De rol waarmee een request naar de dataservice zich mag legitimeren, als HTTP-header. Losse service
 * omdat iedere aanroeper van de dataservice hem nodig heeft: zowel de dashboardqueries in
 * `DataService` als de AI-chat in `AssistantService`.
 */
@Injectable({
	providedIn: 'root',
})
export class RolHeaderService {
	private readonly restLoggingService = inject(RestLoggingService);

	getActiveRolHeader(): {} | { 'X-Restrict-Authorization': string } {
		const currentDashboard = this.restLoggingService.currentDashboard();

		if (currentDashboard?.startsWith('/beheer/')) {
			return this.getRolHeader(RolRestriction.BEHEERDER);
		}

		const rol = sessionStorage.getItem('rol') as RRol; // eigenlijk rolService.getActiveRol() maar circular injection kan niet
		if (isNil(rol)) return {};

		if (rol === RRol.TEAMLEIDER && currentDashboard?.startsWith('/details/leerling'))
			return this.getRolHeader(RolRestriction.TEAMLEIDER_VIA_LEERLING);

		return this.getRolHeader(rol as unknown as RolRestriction);
	}

	private getRolHeader(rol: RolRestriction) {
		return { [DataserviceHttpHeaders.X_RESTRICT_AUTHORIZATION]: rol };
	}
}
